import React,{useState,useEffect} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';
import { formatDate } from '../../utils/CommonLibrary';
import { agent_members_reached_graph } from '../../../services/met/Service';

// Initialize exporting module
exporting(Highcharts);

const MembersReachedBar = ({startDate,endDate,agentId,parentCallback}) => {
  // Define your data
  // const months = ['3 Jul', '4 Jul', '5 Jul', '6 Jul', '7 Jul', '8 Jul', '9 Jul'];
  // const callsBooked = [255, 225, 75, 75, 294, 291, 285];

  
  const [loadingCount, setLoadingCount] = useState(0);
  const [graphData, setGraphData] = useState([]);
  const [callsBooked, setCallsBooked] = useState([]);
  const [weekBooked, setWeekBooked] = useState([]);
  
  useEffect(() => {
    agentMembersReachedGraph();    
}, [agentId,startDate,endDate]);

  const agentMembersReachedGraph = async () => {
    try {
        let sdate = formatDate(startDate);
        let edate = formatDate(endDate);
        let response = await agent_members_reached_graph(sdate,edate,agentId);
        if(response.data.code === 200){
            setGraphData(response.data.data);
            setLoadingCount(response.data.data.length);
            parentCallback(response.data.memberReachedCount);
        }
    } catch (error) {
        console.log(error);
    }
}

useEffect(() => {
  if (graphData.length > 0) {
    const dates = graphData.map((item) => item.placedCallDate);
    const counts = graphData.map((item) => item.totalCount);
    setWeekBooked(dates);
    setCallsBooked(counts);
  }
}, [graphData]);

  const yAxisJson = {
    title: {
      text: null
    }
  };

  const tooltipJson = {
    shared: true,
    valueSuffix: ''
  };

  const seriesData = [{
    name: 'Members Reached',
    data: callsBooked,
    color: '#2266A6'
  }, ];

  const optionsMCI1 = {
    chart: {
      type: 'column',
      height: 200,
      spacing: [20, 0, 0, 0],
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 10,
        depth: 50,
        viewDistance: 25
      }
    },
    title: {
      text: null,
      align: 'left',
      style: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#333',
        fontFamily: "IBM Plex Sans, sans-serif"
      }
    },
    xAxis: {
      categories: weekBooked,
      gridLineWidth: 0
    },
    yAxis: yAxisJson,
    tooltip: tooltipJson,
    plotOptions: {
      column: {
        borderRadius: 5,
        pointPadding: 0.2,
        groupPadding: 0.1,
        stacking: null, // Use null for side-by-side columns
        dataLabels: {
          enabled: true,
          style: {
            textOutline: 'none'
          }
        }
      }
    },
    series: seriesData,
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    legend: {
      enabled: false
    }
  };

  return (
    <>
    {loadingCount > 0 ? (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={optionsMCI1}
      />
    </div>
    ) : (
      <div className="emty-column">
                                    <h5 className="emty-title-graph">There are no data to display</h5>
                                </div>
    )} 
    </>
  );
};

export default MembersReachedBar;
